(() => {
  'use strict';
  const dialog = document.getElementById('FitouchWelcome');
  const dismissedKey = 'fitouch.welcome.dismissed.v1';
  const returnKey = 'fitouch.welcome.return.v1';
  let closed = false;
  let trigger;
  let previousFocus;
  let scrollPosition = 0;
  let originalOverflow;
  let originalPadding;
  const storage = {
    get(store, key) { try { return window[store].getItem(key); } catch (_) { return null; } },
    set(store, key, value) { try { window[store].setItem(key, value); } catch (_) {} },
    remove(store, key) { try { window[store].removeItem(key); } catch (_) {} }
  };
  const pagePath = () => location.pathname + location.search + location.hash;
  const rememberDismissal = () => {
    closed = true;
    storage.set('localStorage', dismissedKey, '1');
    clearTimeout(trigger);
  };
  // Native login return keeps the originating page; retain its scroll position
  // across authentication without storing the shopper's email in browser storage.
  const restoreReturn = () => {
    const saved = storage.get('sessionStorage', returnKey);
    if (!saved) return;
    try {
      const state = JSON.parse(saved);
      if (Date.now() - state.at > 30 * 60 * 1000 || state.path !== pagePath()) return;
      storage.remove('sessionStorage', returnKey);
      requestAnimationFrame(() => window.scrollTo({ top: state.y, behavior: 'instant' }));
    } catch (_) { storage.remove('sessionStorage', returnKey); }
  };
  if (document.readyState === 'complete') restoreReturn();
  else window.addEventListener('load', restoreReturn, { once: true });
  window.addEventListener('pageshow', restoreReturn);
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('form');
  const email = dialog.querySelector('#FitouchWelcomeEmail');
  const consent = dialog.querySelector('[data-welcome-consent]');
  const submit = dialog.querySelector('[type="submit"]');
  const desktopMedia = window.matchMedia('(min-width: 761px)');
  const visual = dialog.querySelector('[data-image-url]');
  const loadVisual = () => {
    if (desktopMedia.matches) visual.style.backgroundImage = `url("${visual.dataset.imageUrl}")`;
  };
  desktopMedia.addEventListener?.('change', () => { if (dialog.open) loadVisual(); });
  const otherOverlayOpen = () =>
    document.body.matches('.nav-menu-open,.search-drawer-open,.mini-cart-open,.profile-panel-open') ||
    !!document.querySelector('dialog[open]:not(#FitouchWelcome)');
  const open = () => {
    if (dialog.open || otherOverlayOpen()) return false;
    clearTimeout(trigger);
    previousFocus = document.activeElement;
    scrollPosition = window.scrollY;
    originalOverflow = document.body.style.overflow;
    originalPadding = document.body.style.paddingRight;
    const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    if (scrollbar) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
    document.body.style.overflow = 'hidden';
    loadVisual();
    dialog.showModal();
    // Start on the close control, preventing the mobile keyboard covering copy.
    dialog.querySelector('[data-welcome-close]').focus({ preventScroll: true });
    return true;
  };
  const close = () => { rememberDismissal(); dialog.close(); };
  dialog.querySelector('[data-welcome-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', rememberDismissal);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = originalOverflow;
    document.body.style.paddingRight = originalPadding;
    window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    previousFocus?.focus?.({ preventScroll: true });
  });
  document.querySelectorAll('[data-welcome-open]').forEach((button) => {
    button.addEventListener('click', open);
  });
  const schedule = () => {
    if (closed || storage.get('localStorage', dismissedKey) || dialog.open) return;
    if (document.visibilityState !== 'visible' || otherOverlayOpen()) {
      trigger = setTimeout(schedule, 1000);
      return;
    }
    open();
  };
  if (dialog.querySelector('[data-welcome-error]')) open();
  else trigger = setTimeout(schedule, 7000);
  // Leaving and returning through the browser cache must not leave a stuck form.
  window.addEventListener('pageshow', () => {
    submit.disabled = false;
    form.removeAttribute('aria-busy');
    restoreReturn();
  });
  form.addEventListener('submit', (event) => {
    if (!form.reportValidity()) { event.preventDefault(); return; }
    const login = new URL(dialog.dataset.loginUrl, location.origin);
    login.searchParams.set('return_to', pagePath());
    login.searchParams.set('login_hint', email.value.trim());
    storage.set('sessionStorage', returnKey, JSON.stringify({ path: pagePath(), y: scrollPosition, at: Date.now() }));
    rememberDismissal();
    if (!consent.checked) {
      // Never send accepts_marketing=false; don't unsubscribe existing members.
      event.preventDefault();
      window.location.assign(login.href);
      return;
    }
    // Keep the native, CAPTCHA-aware newsletter form. Restore protected hidden
    // fields at submit time (Shopify may blank their initial rendered values).
    [['form_type', 'customer'], ['utf8', '✓'], ['contact[tags]', 'newsletter'],
      ['contact[accepts_marketing]', 'true'], ['return_to', login.pathname + login.search]]
      .forEach(([name, value]) => {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
        input.disabled = false;
        input.value = value;
      });
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
  }, true);
})();
